import { createAction, props } from "@ngrx/store";
import { EmailNotificationSetting } from "src/app/model/notification/EmailNotificationSetting";

export enum EmailNotificationSettingsActionTypes {
    LoadSettings = "[Email Notification Settings] Load Settings",
    LoadSettingsSuccess = "[Email Notification Settings] Load Settings Success",
    LoadSettingsFailure = "[Email Notification Settings] Load Settings Failure",
    UpdateSetting = "[Email Notification Settings] Update Setting",
    UpdateSettingSuccess = "[Email Notification Settings] Update Setting Success",
    UpdateSettingFailure = "[Email Notification Settings] Update Setting Failure",
}

export const loadSettings = createAction(
    EmailNotificationSettingsActionTypes.LoadSettings,
);

export const loadSettingsSuccess = createAction(
    EmailNotificationSettingsActionTypes.LoadSettingsSuccess,
    props<{ settings: EmailNotificationSetting[] }>(),
);

export const loadSettingsFailure = createAction(
    EmailNotificationSettingsActionTypes.LoadSettingsFailure,
    props<{ error: string }>(),
);

export const updateSetting = createAction(
    EmailNotificationSettingsActionTypes.UpdateSetting,
    props<{ eventCode: string; isEnabled: boolean }>(),
);

export const updateSettingSuccess = createAction(
    EmailNotificationSettingsActionTypes.UpdateSettingSuccess,
    props<{ setting: EmailNotificationSetting }>(),
);

export const updateSettingFailure = createAction(
    EmailNotificationSettingsActionTypes.UpdateSettingFailure,
    props<{ eventCode: string; error: string }>(),
);
